import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const getAdminChartData = async (filters) => {
  try {
    const res = await API.get_dashbaord_chart_data(filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdminKpiData = async (filters) => {
  try {
    const res = await API.get_admin_kpi_data(filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdminPerformanceData = async (
  pageNum,
  filters,
  pageSize,
  searchString,
sortField,
sortOrder
) => {
  try {
    const res = await API.get_admin_performance_data(
      pageNum,
      filters,
      pageSize,
      searchString,
      sortField,
sortOrder
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
